import { render, staticRenderFns } from "./teacherItem.vue?vue&type=template&id=35fd38f1&"
import script from "./teacherItem.vue?vue&type=script&lang=js&"
export * from "./teacherItem.vue?vue&type=script&lang=js&"
import style0 from "./teacherItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports